/* Owl Carousel (bundled inside theme.min.js) permanently stops the homepage
   slideshow's autoplay: FullscreenSlider's own pagination-dot click handler
   calls the plugin's real stop() method directly (theme.js, eventListeners),
   which sets an internal apStatus flag that nothing ever sets back — so once
   a user clicks a dot (or, via bfcache, navigates back to a frozen instance),
   autoplay never runs again. theme.min.js is a minified build with no
   matching readable source in this repo, so rather than hand-editing the
   minified bundle, this resumes autoplay from the outside by calling the
   plugin instance's own play() method directly (the same instance FullscreenSlider
   itself holds as `slider.owl`, retrieved here via jQuery's .data('owlCarousel')). */
(function ($) {
  if (!$) return;

  var RESUME_DELAY = 4000;
  var timers = new WeakMap();

  function resumableSliders() {
    return $('.section--slideshow .slider[data-autoplay="true"]');
  }

  function getOwlInstance($slider) {
    return $slider.find('.owl-carousel').data('owlCarousel');
  }

  function scheduleResume($slider) {
    var el = $slider.get(0);
    var owl = getOwlInstance($slider);
    if (!owl || typeof owl.play !== 'function') return;

    clearTimeout(timers.get(el));
    timers.set(el, setTimeout(function () {
      owl.play();
    }, RESUME_DELAY));
  }

  function onSliderInteraction(e) {
    var $slider = $(e.target).closest('.section--slideshow .slider[data-autoplay="true"]');
    if ($slider.length) {
      scheduleResume($slider);
    }
  }

  $(document).on('mouseup touchend click', onSliderInteraction);

  // Fix: page restored from bfcache (navigating back) can leave the carousel
  // frozen since its autoplay was stopped before navigating away.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    resumableSliders().each(function () {
      scheduleResume($(this));
    });
  });
})(window.jQuery);
